import { formatCurrencyAmountWithIssue } from '../../../commons/currency/Currency.Functions';
import { SettlementDebt } from "../../../models/Entities/SettlementDebt/SettlementDebt";

interface SettlementDebtsInfoProps {
    SettlementDebts: SettlementDebt[];
}

const fmt = (amount: number, currency: string) => formatCurrencyAmountWithIssue(amount, currency);

const SettlementDebtsInfoComponent = ({ SettlementDebts }: SettlementDebtsInfoProps) => {
    if (!SettlementDebts || SettlementDebts.length === 0) return null;

    return (
        <table className="sdd-debt-table">
            <thead>
                <tr className="sdd-debt-thead">
                    <th className="sdd-debt-th"></th>
                    <th className="sdd-debt-th sdd-debt-th--amount">Importe original</th>
                    <th className="sdd-debt-th">Estado</th>
                    <th className="sdd-debt-th sdd-debt-th--amount">Saldo pendiente</th>
                </tr>
            </thead>
            <tbody>
                {SettlementDebts.map((settlementDebt) => {
                    const cashFlowDebt = settlementDebt.CashFlowDebt;
                    if (!cashFlowDebt) return null;

                    const isPaid = cashFlowDebt.pendingAmount === 0;
                    const currency = cashFlowDebt.currencyCode?.toUpperCase() || 'ARS';
                    const hasConversion =
                        cashFlowDebt.originalCurrencyCode &&
                        cashFlowDebt.originalCurrencyCode.toUpperCase() !== currency &&
                        cashFlowDebt.originalAmountInOriginalCurrency != null;
                    const originalCurrency = cashFlowDebt.originalCurrencyCode?.toUpperCase() || currency;

                    return (
                        <tr
                            key={`${settlementDebt.id}-${settlementDebt.debtId}`}
                            className={`sdd-debt-row${isPaid ? ' sdd-debt-row--paid' : ' sdd-debt-row--pending'}`}
                        >
                            {/* indicator */}
                            <td className="sdd-debt-td sdd-debt-td--indicator">
                                <span className={`sdd-debt-dot${isPaid ? ' sdd-debt-dot--paid' : ' sdd-debt-dot--pending'}`} />
                            </td>

                            {/* amount */}
                            <td className="sdd-debt-td sdd-debt-td--amount">
                                <span className="sdd-debt-amount">{fmt(cashFlowDebt.originalAmount, currency)}</span>
                                {hasConversion && (
                                    <span className="sdd-debt-conversion">
                                        {fmt(cashFlowDebt.originalAmountInOriginalCurrency, originalCurrency)} {originalCurrency}
                                    </span>
                                )}
                            </td>

                            {/* status badge */}
                            <td className="sdd-debt-td">
                                <span className={`sdd-debt-badge${isPaid ? ' sdd-debt-badge--paid' : ' sdd-debt-badge--pending'}`}>
                                    {isPaid ? 'Pagada' : 'Pendiente'}
                                </span>
                            </td>

                            {/* pending amount */}
                            <td className="sdd-debt-td sdd-debt-td--amount">
                                {isPaid ? (
                                    <span className="sdd-debt-zero">—</span>
                                ) : (
                                    <span className="sdd-debt-pending">{fmt(cashFlowDebt.pendingAmount, currency)}</span>
                                )}
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};

export default SettlementDebtsInfoComponent;